import { MissingTranslationHandler } from '@ngx-translate/core';
import type { MissingTranslationHandlerParams } from '@ngx-translate/core';
import { resolveAssetTemplateTranslation } from '../pipes/translate-optional-key.pipe';

export class AssetTemplateMissingTranslationHandler implements MissingTranslationHandler {
  public handle(params: MissingTranslationHandlerParams): string {
    return (
      resolveAssetTemplateTranslation(
        params.translateService,
        params.key,
        params.interpolateParams
      ) ?? params.key
    );
  }
}
